import { Box } from '@mui/material';
import { Route } from 'app/enums';
import { ActiveMatchContext } from 'modules/bracket/providers';
import React, { FC, useCallback, useContext, useMemo } from 'react';
import { NotificationEntity } from 'app/interfaces/entity';
import { NotificationGameIcon } from 'modules/notifications/components/NotificationGameIcon';
import { BaseNotificationTile } from 'modules/notifications/components/BaseNotificationTile';
import { useNavigate } from 'react-router-dom';

interface TournamentMatchFinishedTileProps {
  notification: NotificationEntity<number>;
}

export const TournamentMatchFinishedTile: FC<TournamentMatchFinishedTileProps> = ({
  notification,
}) => {
  const navigate = useNavigate();
  const { setActiveMatchId } = useContext(ActiveMatchContext);

  const tournamentGameIcon = useMemo(
    () => notification.tournament?.game?.icon ?? '',
    [notification]
  );

  const tournamentName = useMemo(
    () => notification?.tournament?.name,
    [notification?.tournament?.name]
  );

  const onClickHandler = useCallback(
    (event) => {
      event.stopPropagation();
      setActiveMatchId(notification.payload);
      navigate(Route.TournamentBracket.replace(':id', notification?.tournament?.id ?? ''));
    },
    [navigate, notification, setActiveMatchId]
  );

  return (
    <Box onClick={onClickHandler}>
      <BaseNotificationTile
        image={<NotificationGameIcon icon={tournamentGameIcon} />}
        message={notification?.message ?? `${tournamentName} match has finished.`}
        date={notification.createdAt}
        seen={notification.seen}
      />
    </Box>
  );
};
